import UAParser from 'ua-parser-js';

export const getUserDevice = () => {
  const parser = new UAParser();
  return parser.getDevice();
};
